'use client'

import cn from 'clsx'
import { Button } from '@/components/Button/Button'
import type { ButtonProps } from '@/components/Button/Button'

import css from './OverlayButton.module.css'

export type OverlayButtonProps = Omit<
    ButtonProps,
    'variant' | 'href' | 'tag' | 'weight' | 'gap' | 'borderRadius' | 'animating' | 'loadingLabel'
> & {
    onClick?: () => void
    size?: 'large' | 'base' | 'small'
    variant?: 'rounded' | 'squared'
}

export function OverlayButton({
    children,
    onClick,
    size = 'base',
    className,
    variant = 'rounded',
    ...rest
}: OverlayButtonProps) {
    return (
        <Button
            size={size}
            onClick={onClick}
            className={cn([css[size], css.videoOverlay, css[variant], className])}
            {...rest}
        >
            {children}
        </Button>
    )
}
